import { Button, Chip, FormControl, FormHelperText, Grid, InputAdornment, OutlinedInput, TextField, makeStyles, useTheme } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";

const useStyles = makeStyles(theme => ({
    form: {
        padding: "0px 20px 20px 20px"
    },
    emailInput: {
        width: "100%",
        '& .MuiInputBase-input': {
            border: "unset !important"
        }
    },
    tagHeading: {
        color: "#3F4254",
        fontFamily: "Roboto",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "12px",
    },
    chip: {
        margin: theme.spacing(0.5),
        backgroundColor: "#F3F6F9",
        color: "#70808F",
        fontFamily: "Roboto",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "145%",
    },
    showMore: {
        margin: theme.spacing(0.5),
        backgroundColor: "#3699FF",
        color: "#fff !important",
        fontFamily: "Roboto",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "145%",
        padding: "7px",
        borderRadius:"20px",
        cursor:"pointer",
    },
    showMoreBox:{
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
    },
    noTagText: {
        color: "#70808F",
        textAlign: "center",
        fontFamily: "Roboto",
        fontSize: "12px",
        fontStyle: "italic",
        fontWeight: "500",
        lineHeight: "12px",
        marginTop: "8px",
    },
    tagBox: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "start",
        maxHeight: "40px",
        overflowY: "auto",
    },
    tagsHeadings: {
        color: "#2d3339",
        fontSize: "14px",
        fontWeight: "500",
    },
    contentBox: {
        '& textarea': {
            height: "120px !important",
            minHeight: "120px !important"
        }
    },
    notFoundText: {
        textAlign: "center",
        opacity: 0.5,
        fontSize: "12px",
        fontWeight: 500,
    },
    chipsContainer:{
        height:"300px",
        overflowY:"auto"
    },
    FrolaEditor:{
     maxHeight:"200px",
     overflowY:"auto",
     marginBottom:"15px",
    },
}))

const CampaignPreviewForm = ({
    open,
}) => {
    const classes = useStyles();
    return (
        <Grid className={classes.form}>
            <div className={classes?.chipsContainer}>
            <div>
                <h2 className={classes.tagsHeadings}> End Users </h2>
                <UsersChips
                    chipdata={open?.campaignEndUsers}
                    notFoundMessage={"No End User Added"}
                />
            </div>
            <div>
                <h2 className={classes.tagsHeadings}> Business Users </h2>
                <UsersChips
                    chipdata={open?.businessUsers}
                    notFoundMessage={"No Business User Added"}
                />
            </div>
            <div>
                <h2 className={classes.tagsHeadings}> Leads </h2>
                <UsersChips
                    chipdata={open?.campaignLeadUsers}
                    notFoundMessage={"No Lead Added"}
                />
            </div>
            </div>
            <div className='marketingContent'>
               <h2 className={classes.tagsHeadings}> Content </h2>
            <div className="floraEditor">
            <FroalaEditorView model={open?.body} /> 
            </div>
            
          </div>
        </Grid>
    )
}

export default CampaignPreviewForm;


const UsersChips = ({
    chipdata = [],
    notFoundMessage
}) => {
    const classes = useStyles();
    const [showMoreChips , setShowMoreChips] = useState(3)
    function truncate(campaign) {
        if (campaign && campaign.length > 35) {
          return campaign.substring(0, 33) + "...";
        }
        return campaign;
      }
    return (
        <div className='marketingChips'>
            {
                chipdata?.length ? <div className={classes.tagBox}>
                    {chipdata?.slice(0, showMoreChips ).map((tag) => (
                        <Chip
                            label={truncate(tag.fullName)}
                            // onDelete={() => handleDelete()}
                            className={classes.chip}
                        />
                    ))}
                    <div className={classes.showMoreBox}>
                        
                        {chipdata?.length > 3 ? (
                           showMoreChips === 3 ? <div className={classes.showMore} 
                           onClick={()=> setShowMoreChips(chipdata?.length)}>
                             {`+ ${chipdata?.length - 3}`}
                            </div>  :
                        <div className={classes.showMore} onClick={()=> setShowMoreChips(3)}>
                         Show Less
                        </div>
                        ) : null}
                    </div>
                </div> : <div className={classes.notFoundText}>
                    {notFoundMessage}
                </div>
            }
        </div>
    )
}
